<!-- 公共顶部描述 -->
<template>
    <div class="topBox commonPadding">
        <div class="topLeft">
            <i class="iconfont icon-zhiwu topLeftIcon"></i>
            <div class="topLeftText">{{ cropName || "-" }}</div>
        </div>
        <div class="topRight">
            <i class="iconfont icon-yirenzheng topRightIcon"></i>
            <div class="topRightText">{{ $t("common.certified") }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cropName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped>
.topBox {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(240, 246, 255, 1);
}

.topLeft {
    width: fit-content;
    display: flex;
    align-items: center;
    column-gap: 8px;
}

.topLeftIcon {
    font-size: 30px;
    color: var(--h5-color-blue);
}

.topLeftText {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0px;
    color: var(--h5-color-blue);
}

.topRight {
    width: fit-content;
    display: flex;
    align-items: center;
    column-gap: 5px;
}

.topRightIcon {
    font-size: 14px;
    color: var(--h5-color-green);
}

.topRightText {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    color: var(--h5-color-green);
}
</style>